import {useSelector} from 'react-redux';
import {RsvpStatuses} from '~/ViewInvitation/common/RSVPModalVariantAB/types';
import {
  selectAllowGuestsToBringMoreGuests,
  selectAllowKids,
} from '~/ViewInvitation/selectors/eventDetails';
import {Counter} from '~library/atoms/Counter';

import './PlusOneInput.sass';

type RSVPModalVariantABContentProps = {
  status: RsvpStatuses;
  numAdults: number;
  numKids: number;
  onNumberOfAdultsChange: (value: number) => void;
  onNumberOfKidsChange: (value: number) => void;
};

export const PlusOneInput = ({
  status,
  numAdults,
  numKids,
  onNumberOfAdultsChange,
  onNumberOfKidsChange,
}: RSVPModalVariantABContentProps) => {
  const allowKids = useSelector(selectAllowKids);
  const allowGuestsToBringMoreGuests = useSelector(selectAllowGuestsToBringMoreGuests);

  if (status === RsvpStatuses.No || !allowGuestsToBringMoreGuests) {
    return null;
  }

  return (
    <div className="collect-info__guests-count">
      <Counter
        count={numAdults}
        title={allowKids ? 'Total Adults*' : 'Total Guests*'}
        onPlus={() => onNumberOfAdultsChange(numAdults + 1)}
        onMinus={() => onNumberOfAdultsChange(Math.max(0, numAdults - 1))}
        data-qa-id="adults-count"
        inputCallback={(val: number) => onNumberOfAdultsChange(val)}
      />
      {allowKids && (
        <Counter
          title="Total Kids*"
          count={numKids}
          onPlus={() => onNumberOfKidsChange(numKids + 1)}
          onMinus={() => onNumberOfKidsChange(Math.max(0, numKids - 1))}
          data-qa-id="kids-count"
          inputCallback={(val: number) => onNumberOfKidsChange(val)}
        />
      )}
    </div>
  );
};
